import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LocationService } from '@app/_services';
import { first } from 'rxjs/operators';

@Component({
    selector: 'frontline-community-data',
    templateUrl: 'frontline-communities.component.html',
})

export class FrontlineCommunitiesComponent {

    @Input() zipCode: any;
    @Input() device: any;
    frontLineData:any;

    constructor(private locationService : LocationService) { }
    ngOnInit() {
        this.locationService.getFrontlineCommunityResults().pipe(first()).subscribe(data => {
            this.frontLineData = data;

            this.frontLineData.forEach(row => {

                row.poverty = row.pct_poverty_level_200 * 100;
                row.unemployment = row.unemployment_rate * 100;
                row.bipoc = row.pct_bipoc * 100;
                row.disability = row.pct_w_disability * 100;
                row.under17over65 = row.pct_under17_over65 * 100;
                row.limitedEnglish = row.pct_ltd_english * 100;
                row.houses = row.pct_home_owners_housing_burdened * 100;
            });
        });
    }
}
